import { render } from "./PopupPanel.vue?vue&type=template&id=e80ccdfe"
import script from "./PopupPanel.vue?vue&type=script&lang=js"
export * from "./PopupPanel.vue?vue&type=script&lang=js"

import "./PopupPanel.vue?vue&type=style&index=0&id=e80ccdfe&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__